import { useTranslation } from "react-i18next";

export const TaskTypeDetailHeaderComponent = ({ taskTypeData }) => {
  const { t } = useTranslation(["TaskTypes"]);
  const taskType = {
    Id: taskTypeData?.Id,
    Title: taskTypeData?.Title,
    Key: taskTypeData?.Key,
    BoardId: taskTypeData?.BoardId,
  };

  return (
    <div className="d-flex justify-content-between">
      <div>
        <span className="labels">{t("TaskType")}</span>
        <label className="task-type-key">{taskType?.Title}</label>
      </div>
      <div>
        <span className="labels">{t("Key")}</span>
        <label className="task-type-key">{taskType?.Key}</label>
      </div>
    </div>
  );
};
